import React from "react";
import { Navbar, NavbarBrand } from "reactstrap";

const AuthNavbar = _ => {
	return (
		<div>
			<Navbar color="light" light expand="md" className="shadow p-1">
				<NavbarBrand>
		
				</NavbarBrand>
			</Navbar>
		</div>
	);
};

export default AuthNavbar;
